/**
 * Web Vitals性能指标监控
 * 
 * 监控的指标包括:
 * - CLS (Cumulative Layout Shift): 累积布局偏移，衡量视觉稳定性
 * - FID (First Input Delay): 首次输入延迟，衡量交互性
 * - FCP (First Contentful Paint): 首次内容绘制，衡量加载速度
 * - LCP (Largest Contentful Paint): 最大内容绘制，衡量感知加载速度
 * - TTFB (Time to First Byte): 首字节时间，衡量服务器响应速度
 * 
 * @param {Function} onPerfEntry - 性能指标回调函数
 */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // 累积布局偏移 (CLS)
      getCLS(metric => {
        console.log('CLS:', metric.value);
        onPerfEntry({
          ...metric,
          category: 'Web Vital',
          name: 'CLS'
        });
      });
      
      // 首次输入延迟 (FID)
      getFID(metric => {
        console.log('FID:', metric.value);
        onPerfEntry({
          ...metric,
          category: 'Web Vital',
          name: 'FID'
        });
      });
      
      // 首次内容绘制 (FCP)
      getFCP(metric => {
        console.log('FCP:', metric.value);
        onPerfEntry({
          ...metric,
          category: 'Web Vital',
          name: 'FCP'
        });
      });
      
      // 最大内容绘制 (LCP)
      getLCP(metric => {
        console.log('LCP:', metric.value);
        onPerfEntry({
          ...metric,
          category: 'Web Vital',
          name: 'LCP'
        });
      });
      
      // 首字节时间 (TTFB)
      getTTFB(metric => {
        console.log('TTFB:', metric.value);
        onPerfEntry({
          ...metric,
          category: 'Web Vital',
          name: 'TTFB'
        });
      });
    });
  }
};

export default reportWebVitals; 